import { Backlog } from "../../../cmps/util-cmps/backlog"
import { Spinner } from "../../../cmps/util-cmps/spinner"
import { useEscapeKey } from "../../../hooks/use-escape-key"
import { useScrollLock } from "../../../hooks/use-scroll-lock"
import { useFocusTrap } from "../../../hooks/use-focus-trap"
import { useDraggable } from "../../../hooks/use-draggable"

interface FormModalProps {
    header: string
    zIndex?: number
    children: React.ReactNode
    onCloseModal: () => void
    actionBtnText?: string
    onActionBtn?: () => void
    isShowSpinner?: boolean
    hideActionBtn?: boolean
}

export const FormModal: React.FC<FormModalProps> = (
    { header, zIndex = 300, children, onCloseModal, actionBtnText, onActionBtn, isShowSpinner = false, hideActionBtn = false }
) => {
    useEscapeKey(onCloseModal)
    useScrollLock()
    const trapRef = useFocusTrap<HTMLDivElement>()
    const { modalRef, onHeaderMouseDown } = useDraggable<HTMLElement>()

    return <div ref={trapRef}>
        <section ref={modalRef} className="form-modal" style={{ zIndex }} role="dialog" aria-modal="true" aria-label={header}>
            <header onMouseDown={onHeaderMouseDown}>
                <h2>{header}</h2>
                <button className="close-btn" onClick={onCloseModal} aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </header>

            <section className="input-section">
                {children}
                {hideActionBtn && isShowSpinner && (
                    <div className="form-modal__footer form-modal__footer--hidden-action">
                        <Spinner isSmall={true} />
                    </div>
                )}
                {!hideActionBtn && (
                    <div className="form-modal__footer">
                        {!isShowSpinner && onActionBtn && actionBtnText && <button className="main" onClick={onActionBtn}>{actionBtnText}</button>}
                        {isShowSpinner && <Spinner isSmall={true} />}
                    </div>
                )}
            </section>
        </section>
        <Backlog zIndex={zIndex - 1} onCloseBacklog={onCloseModal} />
    </div>
}

interface LoadingErrorModalProps {
    header: string
    zIndex?: number
    isError?: boolean
    onCloseModal: () => void
}

export const LoadingErrorModal: React.FC<LoadingErrorModalProps> = ({ header, zIndex = 300, isError, onCloseModal }) => {
    useEscapeKey(onCloseModal)
    useScrollLock()
    const { modalRef: errorModalRef, onHeaderMouseDown: onErrorHeaderMouseDown } = useDraggable<HTMLElement>()

    return <>
        <section ref={errorModalRef} className="loading-error-modal form-modal" style={{ zIndex }} role="dialog" aria-modal="true" aria-label={header}>
            <header onMouseDown={onErrorHeaderMouseDown}>
                <h2>{header}</h2>
                <button className="close-btn" onClick={onCloseModal} aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </header>

            <div>
                {!isError && <Spinner />}
                {isError && <p className="error-msg">An error occured <br />loading the modal data</p>}
            </div>
        </section>
        <Backlog zIndex={zIndex - 1} onCloseBacklog={onCloseModal} />
    </>
}
